import React from "react";
import Loadable from "react-loadable";

import Waiting from "./common/components/Waiting.js";

const fullPageLoadingStyles = {
  width: "calc(100%)",
  height: "calc(100%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const FullPageLoading = () => (
  <div style={fullPageLoadingStyles}>
    <Waiting />
  </div>
);

export const AsyncMainPage = Loadable({
  loader: () => import("./tenantportal/main/MainPage"),
  loading: FullPageLoading
});

export const AsyncRegisterLogin = Loadable({
  loader: () => import("./tenantportal/register/RegisterLogin"),
  loading: FullPageLoading
});

export const AsyncCreateAccountBasicInfo = Loadable({
  loader: () => import("./tenantportal/register/CreateAccountBasicInfo"),
  loading: FullPageLoading
});

export const AsyncCreateAccountActivation = Loadable({
  loader: () => import("./tenantportal/register/CreateAccountActivation"),
  loading: FullPageLoading
});

export const AsyncInfastructureMain = Loadable({
  loader: () => import("./tenantportal/cloudDevices"),
  loading: FullPageLoading
});

export const AsyncA4BMainPage = Loadable({
  loader: () => import("./tenantportal/a4b/main/A4BMainPage"),
  loading: FullPageLoading
});



// WEBPACK FOOTER //
// ./src/CodeSplitting.js